import React from "react";
import { Check, MessageCircle } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { CONTACT } from "@/i18n/translations";
import { useHome } from "@/i18n/home";

export const UwaDialog = ({ open, onOpenChange }) => {
  const u = useHome().uwa;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[calc(100%-2rem)] max-w-lg overflow-hidden rounded-[1.75rem] sm:rounded-[1.75rem] border-white/10 bg-[#0A0E13] p-0 text-white" data-testid="uwa-dialog">
        <div className="relative flex items-center gap-5 p-7 pb-6" style={{ background: "linear-gradient(135deg, rgba(37,99,235,0.35), rgba(0,195,255,0.08))" }}>
          <img src="/uwa-badge.png" alt="UniFi Wireless Administrator" className="h-20 w-20 shrink-0 rounded-2xl shadow-[0_0_30px_rgba(37,99,235,0.6)]" />
          <div>
            <DialogTitle className="font-display text-xl font-bold leading-tight text-white">UniFi Wireless Administrator</DialogTitle>
            <DialogDescription className="mt-1.5 text-sm text-white/65">{u.lead}</DialogDescription>
          </div>
        </div>
        <ul className="space-y-3.5 px-7 pt-2" data-testid="uwa-dialog-points">
          {u.points.map((p) => (
            <li key={p} className="flex items-start gap-3 text-[15px] text-white/85">
              <span className="mt-0.5 grid h-5 w-5 shrink-0 place-items-center rounded-full" style={{ background: "rgba(0,195,255,0.18)" }}>
                <Check size={12} color="#00C3FF" strokeWidth={3} />
              </span>
              {p}
            </li>
          ))}
        </ul>
        <div className="p-7 pt-7">
          <a
            href={`https://wa.me/${CONTACT.whatsapp}`}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="uwa-dialog-cta"
            className="flex w-full items-center justify-center gap-2 rounded-full py-3.5 text-sm font-semibold text-[#090A0C] transition-transform hover:scale-[1.02]"
            style={{ background: "var(--pt-blue)" }}
          >
            <MessageCircle size={17} /> {u.cta}
          </a>
        </div>
      </DialogContent>
    </Dialog>
  );
};
